import './lookups-705fb53e.js';
import './request.constants-deb285e0.js';
import { s as send, d as downloadDocumentEvent, o as onlineSoftwareModalClickEvent } from './send-33ade633.js';
import { p as parseJsonResponse } from './utils-15ad90ec.js';

const requestRangeSelectorConfig = (host, rangeId, spryKerConfigs) => {
  let url = `${host}product/range/selector-config/${rangeId}`;
  if (spryKerConfigs) {
    url = `${host}/ranges/${rangeId}/selector-config?country-code=${spryKerConfigs.countryCode}&language-code=${spryKerConfigs.languageCode}&brand=${spryKerConfigs.brand}`;
  }
  return fetch(url).then((response) => parseJsonResponse(response));
};
const onDownloadLinkClickGA = (row) => {
  const { reference, fileName, docType } = row;
  if (reference || fileName || docType) {
    send(downloadDocumentEvent, {
      documentReference: reference,
      documentName: fileName,
      documentType: docType,
    });
  }
};
const getPriorityNumber = (numberOfButtonsBefore) => {
  if (numberOfButtonsBefore === 0)
    return 1;
  if (numberOfButtonsBefore === 1)
    return 2;
  if (numberOfButtonsBefore >= 2)
    return 3;
};
const onSoftwareDocumentDialogClick = (type, additionLinks, labels) => {
  const { areaTitle } = labels;
  const softwareModal = document.createElement('pes-software-modal');
  const softwareModalBody = document.createElement('pes-software-modal-body');
  softwareModalBody.data = additionLinks;
  softwareModal.appendChild(softwareModalBody);
  softwareModal.isOpen = true;
  softwareModal.headerLabel = areaTitle;
  softwareModal.addEventListener('didSoftwareModalClose', () => {
    document.body.removeChild(softwareModal);
  });
  document.body.appendChild(softwareModal);
  send(onlineSoftwareModalClickEvent, type);
};

export { onSoftwareDocumentDialogClick as a, getPriorityNumber as g, onDownloadLinkClickGA as o, requestRangeSelectorConfig as r };
